import * as React from 'react';
import * as styles from './ContactButtons.css';

interface IContactButtonsProps {
  callbackButton: React.ReactNode;
  callButton: React.ReactNode;
}

export function ContactButtons({ callbackButton, callButton }: IContactButtonsProps) {
  return (
    <div className={styles['container']}>
      {callButton}
      {callbackButton}
    </div>
  );
}
